<template functional></template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'onetrust',
  props: {
    settings: {
      type: Object,
      default: {
        marketing: '',
      }
    },
    pardot: {
      type: Boolean,
      default: false,
    },
    pardotSettings: {
      type: Object,
      default: () => {
        return {
          Url: 'http://content.niobium.tech/analytics?ver=3',
          CampainId: 7311,
          AccountId: 904131,
          CookieNecessary: 'C0004'
        }
      }
    }
  },
  created() {
    const self = this

    this.init(this.settings)

    window.renewCookieBot = this.renewCookieBot

    window.OptanonWrapper = () => {
      self.initialize(window.OnetrustActiveGroups)

      window.OneTrust.OnConsentChanged((onetrust) => {
        self.changeOneTrust(onetrust.detail)

        if (self.pardot) {
          const groups = self.getConsents(window.OnetrustActiveGroups)
          const { CookieNecessary } = self.pardotSettings
          document.cookie = `pi_opt_in${window.piAId - 1000}=${groups.includes(CookieNecessary)}`
        }
      })
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing',
    ]),
  },
  methods: {
    ...mapActions('onetrust', [
      'check',
      'init'
    ]),
    renewCookieBot() {
      if (event) event.preventDefault()
      window.OneTrust.ToggleInfoDisplay()
    },
    initialize(groups) {
      const dataItems = this.getConsents(groups)

      this.changeOneTrust(dataItems)
    },
    getConsents(groups) {
      return groups.split(',').filter(item => !!item)
    },
    pardotRequest() {
      return new Promise((resolve) => {
        axios.get(this.pardotQuery).then((data) => {
          resolve(data)
        })
      })
    },
    changeOneTrust(data) {
      window.console.log(`CONSENT: ${JSON.stringify(data)}`)

      this.check({
        consent: data,
        consented: this.getInteractionCount() > 0
      })
    },
    getInteractionCount() {
      const { ConsentIntegrationData } = window.OneTrust.GetDomainData()
      return ConsentIntegrationData.consentPayload.customPayload.Interaction
    }
  }
}
</script>
